<template>
  <div>
    <modal-project ref="modalProject" @goTo="$emit('goTo', 'goals')" :currentState="currentState"></modal-project>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import modal from './../shared/modal/modal-project.vue'

export default {
  name: 'project',
  components: {
    'modal-project': modal
  },
  props: {
    currentState: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
    })
  },
  watch: {
    currentState (val, oldVal) {
      if (val === 'project') {
        this.$nextTick(() => {
          this.$emit('goTo2')
        })
      }
    }
  }
}
</script>
